import SignInPromoBannerWrapper from '@/src/components/common/signInPromoBanner'
import { Flight } from '@/src/types/itinerary'
import { transformLayoverData, transformSegmentData } from '@/src/utils/itinerary/flightTransformers'
import { Box } from '@mui/material'
import ImportantMessagesWrapper from '../importantMessages'
import LayoverBlockWrapper from './layoverBlock'
import SegmentBlockWrapper from './segmentBlock'
import SegmentHeaderWrapper from './segmentHeader'

interface FlightDetailsProps {
    flights: Flight[]
    isConfirmationPage?: boolean
    isPnrLoading?: boolean
}

const FlightDetails = ({ flights, isConfirmationPage = false, isPnrLoading = false }: FlightDetailsProps) => {
    return (
        <Box sx={{ width: '100%' }}>
            {flights.map((flight, flightIndex) => {
                const { fromCity, toCity, segments } = flight
                return (
                    <Box key={flightIndex}>
                        <SegmentHeaderWrapper
                            fromCity={fromCity}
                            toCity={toCity}
                            departureDate={flight.segments[0].formattedDepartDateTime}
                            flightIndex={flightIndex}
                            segments={segments}
                            isConfirmationPage={isConfirmationPage}
                            isPnrLoading={isPnrLoading}
                        />

                        <Box
                            sx={{
                                border: '1px solid',
                                borderColor: 'borders.default',
                                borderRadius: 2,
                                mb: 3,
                                py: 2.5
                            }}
                        >
                            {flight.segments.map((segment, segmentIndex) => (
                                <Box key={`${flightIndex}-${segmentIndex}`}>
                                    <SegmentBlockWrapper
                                        segmentData={transformSegmentData(segment)}
                                        isConfirmationPage={isConfirmationPage}
                                    />

                                    {/* Add layover between segments (but not after the last segment) */}
                                    {segmentIndex < flight.segments.length - 1 && (
                                        <LayoverBlockWrapper
                                            layoverData={transformLayoverData(
                                                flight.segments[segmentIndex],
                                                flight.segments[segmentIndex + 1],
                                                flight.layOverDurations[segmentIndex] || 0
                                            )}
                                        />
                                    )}
                                </Box>
                            ))}
                        </Box>
                    </Box>
                )
            })}
            {!isConfirmationPage && <SignInPromoBannerWrapper />}
            <ImportantMessagesWrapper />
        </Box>
    )
}

export default FlightDetails
